export const ModoRegistroEnum = {
  UNIR_CUENTAS: 1,
  CREAR_NUEVA_CUENTA: 2,
  REEMPLAZAR_CUENTA: 3,
} as const;

export type ModoRegistro =
  (typeof ModoRegistroEnum)[keyof typeof ModoRegistroEnum]; // 1 | 2
export type ModoRegistroKey = keyof typeof ModoRegistroEnum;
